import { FormField, FormLabel, FormSelect, Button } from '../ui';
import { FormCpfCnpj, FormPhone, FormInput } from '../ui/FormControls';
import { ParticipantFilterOptions } from '../../types/participant';
import { Search, X } from 'lucide-react';
import { useState } from 'react';

interface ParticipantFiltersProps {
  filters: ParticipantFilterOptions;
  onFilterChange: (filters: ParticipantFilterOptions) => void;
  onResetFilters: () => void;
}

function ParticipantFilters({ filters, onFilterChange, onResetFilters }: ParticipantFiltersProps) {
  const [localFilters, setLocalFilters] = useState<ParticipantFilterOptions>({
    ...filters,
  });

  const handleLocalFilterChange = (name: string, value: string) => {
    setLocalFilters(prev => ({
      ...prev,
      [name]: value || undefined,
    }));
  };

  const handleApplyFilters = () => {
    onFilterChange({
      ...localFilters,
      page: 1, // Reset to first page when filters change
    });
  };

  const hasActiveFilters = Object.keys(filters).some(
    key => key !== 'page' && key !== 'limit' && filters[key as keyof ParticipantFilterOptions]
  );

  return (
    <div className="bg-white dark:bg-gray-800 p-4 rounded-lg shadow mb-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4">
        <FormField>
          <FormLabel htmlFor="full_name">Nome</FormLabel>
          <FormInput
            id="full_name"
            name="full_name"
            value={localFilters.full_name || ''}
            onChange={e => handleLocalFilterChange('full_name', e.target.value)}
            placeholder="Buscar por nome..."
          />
        </FormField>

        <FormField>
          <FormLabel htmlFor="cpf">CPF</FormLabel>
          <FormCpfCnpj
            id="cpf"
            name="cpf"
            type="cpf"
            placeholder="Buscar por CPF"
            value={localFilters.cpf || ''}
            onChange={e => handleLocalFilterChange('cpf', e.target.value)}
          />
        </FormField>

        <FormField>
          <FormLabel htmlFor="city">Cidade</FormLabel>
          <FormInput
            id="city"
            name="city"
            value={localFilters.city || ''}
            onChange={e => handleLocalFilterChange('city', e.target.value)}
            placeholder="Buscar por cidade..."
          />
        </FormField>

        <FormField>
          <FormLabel htmlFor="phone">Telefone</FormLabel>
          <FormPhone
            id="phone"
            name="phone"
            placeholder="Busca por Telefone"
            value={localFilters.phone || ''}
            onChange={e => handleLocalFilterChange('phone', e.target.value)}
          />
        </FormField>

        <FormField>
          <FormLabel htmlFor="email">Email</FormLabel>
          <FormInput
            id="email"
            name="email"
            value={localFilters.email || ''}
            onChange={e => handleLocalFilterChange('email', e.target.value)}
            placeholder="Buscar por email..."
          />
        </FormField>

        <FormField>
          <FormLabel htmlFor="status">Status</FormLabel>
          <FormSelect
            id="status"
            name="status"
            value={localFilters.status || ''}
            onChange={e => handleLocalFilterChange('status', e.target.value)}
          >
            <option value="">Todos</option>
            <option value="pending">Pendente</option>
            <option value="confirmed">Confirmado</option>
          </FormSelect>
        </FormField>
      </div>

      <div className="flex justify-end mt-4 space-x-2">
        {hasActiveFilters && (
          <Button variant="secondary" onClick={onResetFilters} className="flex items-center">
            <X className="h-4 w-4 mr-2" />
            Limpar Filtros
          </Button>
        )}
        <Button onClick={handleApplyFilters} className="flex items-center">
          <Search className="h-4 w-4 mr-2" />
          Filtrar
        </Button>
      </div>
    </div>
  );
}

export default ParticipantFilters;
